import { sendPasswordResetEmail } from "firebase/auth";

import { auth } from "./firebase";

// Registrace žije v AuthPage.tsx (handleRegister). Dřívější registerUser se
// nikde nevolal a měl jiný, chybný postup (ověřovací e-mail před zápisem
// profilu, where('email') citlivé na velikost písmen, alert) – smazán v kroku 5.

/**
 * Obnova hesla – centralizovaná funkce.
 * Rate limiting (cooldown) je řešen na úrovni UI v AuthPage.tsx.
 * Tuto funkci volej VŽDY přes AuthPage, nikdy přímo sendPasswordResetEmail.
 */
export const resetPassword = async (email: string): Promise<void> => {
  try {
    await sendPasswordResetEmail(auth, email, {
      url: "https://lks-apka.netlify.app/password-reset-complete",
      handleCodeInApp: false,
    });

    console.log("Resetovací email byl odeslán.");
  } catch (error: any) {
    console.error("Chyba při resetu hesla:", error);
    throw error;
  }
};
